export enum UploadState {
    NotUploaded,
    UploadingToBlob,
    ReductoProcessing,
    Done
}